import { connectCable, disconnectCable } from "@estaly/ui";

const SET_CONNECTION = "SET_CONNECTION";
const CLEAR_CONNECTION = "CLEAR_CONNECTION";

export default {
  namespaced: true,

  state: {
    isConnected: false,
  },

  mutations: {
    [SET_CONNECTION](state) {
      state.isConnected = true;
    },

    [CLEAR_CONNECTION](state) {
      state.isConnected = false;
    },
  },

  actions: {
    connect({ commit, state }, forceReconnect = false) {
      if (!forceReconnect && state.isConnected) return;

      // Déconnecter d'abord si une connexion existe
      if (state.isConnected) {
        disconnectCable();
        commit(CLEAR_CONNECTION);
      }

      try {
        connectCable({
          apiBaseUrl: process.env.VUE_APP_API_BASE_URL,
          namespace: "store",
          onMessage: (data) => {
            console.log("Received notification:", data);
            this.dispatch("notifications/notify", {
              category: "simple",
              type: data.type || "info",
              title: data.title,
              text: data.message,
              iconComponent: data.iconComponent,
              iconColor: data.iconColor,
            });
          },
        });

        commit(SET_CONNECTION);
      } catch (error) {
        console.error("Failed to connect to cable:", error);
      }
    },

    forceReconnect({ dispatch }) {
      return dispatch("connect", true);
    },

    disconnect({ commit }) {
      try {
        disconnectCable();
        commit(CLEAR_CONNECTION);
      } catch (error) {
        console.error("Failed to disconnect from cable:", error);
        throw error;
      }
    },
  },
};
